module.exports = __webpack_public_path__ + "static/media/kyoto-japan.6dfe9eb1.jpg";